//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FaqItem from '~/components/basics/FaqItem.vue';
export default {
  components: { FaqItem },
  data() {
    return {
      faqs: require('~/content/raw/faqs.js').default
    };
  },
  computed: {
    faqsOdd() {
      return this.faqs.filter((f, index) => index % 2 === 0);
    },
    faqsEven() {
      return this.faqs.filter((f, index) => index % 2 !== 0);
    }
  }
};
